import React from "react";
import SiteShopOrdersPage from "./SiteShopOrdersPage";
import useOrders from "./useOrders";

function SiteShopOrders() {
  return <SiteShopOrdersPage {...useOrders()} />;
}

export default SiteShopOrders;
